export default __webpack_public_path__ + "static/media/Shape 45.97da997c.svg";